export const POS_QUICK_LOADING = "POS_QUICK_LOADING";
export const POS_QUICK_LAYOUT = "POS_QUICK_LAYOUT";
export const POS_QUICK_ERROR = "POS_QUICK_ERROR";
export const POS_QUICK_RESET = "POS_QUICK_RESET";
